import { useRef, useState } from 'react';
import clsx from 'clsx';
import { PaletteUtils } from '@shared/utils';

type InputProps = {
  length?: number;
  onComplete: (pin: string) => void;
};

export const OTPInput = ({ length = 6, onComplete }: InputProps) => {
  const inputRef = useRef<HTMLInputElement[]>(Array(length).fill(null));

  const [OTP, setOTP] = useState<string[]>(Array(length).fill(''));

  const handleTextChange = (input: string, index: number) => {
    const newPin = [...OTP];
    newPin[index] = input;
    setOTP(newPin);

    if (input.length === 1 && index < length - 1) {
      inputRef.current[index + 1]?.focus();
    }

    if (input.length === 0 && index > 0) {
      inputRef.current[index - 1]?.focus();
    }

    if (newPin.every((digit) => digit !== '')) {
      onComplete(newPin.join(''));
    }
  };

  return (
    <div className='flex'>
      {Array.from({ length }, (_, index) => (
        <input
          key={index}
          type='text'
          maxLength={1}
          value={OTP[index]}
          onChange={(e) => handleTextChange(e.target.value, index)}
          ref={(ref) => (inputRef.current[index] = ref as HTMLInputElement)}
          className={clsx(
            'border border-solid dark:bg-slate p-1 w-10 h-10 outline-none text-center',
            PaletteUtils.isInsigniaPalette && 'border-slate-500 focus:border-primary',
            PaletteUtils.isVcfcPalette && 'border-light focus:border-primary-darkest',
          )}
          style={{ marginRight: index === length - 1 ? '0' : '10px' }}
        />
      ))}
    </div>
  );
};
